<template>
  <img src="../assets/lunar_logo.png" width="50" alt=" ">
</template>
<script>
export default {
  name: "VaIconTHCOM",
};
</script>
